if (!customElements.get('lookbook-img')) {
  customElements.define('lookbook-img', class Lookbook extends HTMLElement {
    constructor() {
      super();

      this.pinType = this.querySelectorAll('.pin__type');

      if (this.pinType.length > 0) {
        this.loadClick();
      }

      if (window.innerWidth > 749) return;
      const lookbookBannerImage = this.querySelector(".banner");
      const lookbookSliderControls = this.querySelector(".slider-buttons");

      if (lookbookBannerImage && lookbookSliderControls) {
        const updateLookbookSliderControlsPosition = () => {
          const bannerHeight = lookbookBannerImage.offsetHeight;
          lookbookSliderControls.style.top = `calc(${bannerHeight}px - 6rem)`;
        };

        updateLookbookSliderControlsPosition();

        window.addEventListener("resize", updateLookbookSliderControlsPosition);
      }
    }

    loadClick() {
      this.pinType.forEach((pin) => {
        pin.addEventListener('click', (e) => {
          const target = e.target;
          const gridBlock = target.closest('.grid');
          const similarBlock = target.closest('.pin__type').dataset.block;
          gridBlock.querySelectorAll('.pin__type').forEach((element) => element.classList.remove('active'));
          gridBlock.querySelectorAll('.lookbook-product-item').forEach((element) => element.classList.remove('active'));
          gridBlock.querySelector(`.${similarBlock}`).classList.add('active');
          target.closest('.pin__type').classList.add('active');
        })
      })
    }
  });
}
